import styled from "@emotion/styled";

const ButtonWrapper = styled.div`
  padding-bottom: 1rem;
`;

export default ButtonWrapper;
